import { type CardContentsComponent } from 'components/CardLayoutEditor/models/types';
import React from 'react';

const ProgressContents: React.FC<CardContentsComponent<'progress'>> = ({
  progress,
}) => {
  return (
    <div style={{ height: '1em', display: 'flex', alignItems: 'center' }}>
      <aha-progress-bar
        completed={Math.min(100, progress)}
        total={100}
        no-text
        height='.7em'
        style={{
          '--aha-progress-bar--bar': 'var(--theme-green-border)',
          width: 80,
        }}
      />
    </div>
  );
};

export default ProgressContents;
